import React from 'react';
import { GeoJSON, LayerGroup, Pane } from 'react-leaflet';

const HIGHWAYS_GEOJSON_URL = `${
  process.env.PUBLIC_URL || ''
}/static/highways_vn.geojson`;
const HIGHWAYS_PANE_NAME = 'highways-overlay-pane';
const HIGHWAYS_LAYER_STYLE = Object.freeze({
  color: '#0b7ad1',
  weight: 2,
  opacity: 0.6
});

let highwaysGeoJsonCache = null;
let highwaysGeoJsonRequest = null;

const loadHighwaysGeoJson = async () => {
  if (highwaysGeoJsonCache) {
    return highwaysGeoJsonCache;
  }

  if (!highwaysGeoJsonRequest) {
    highwaysGeoJsonRequest = fetch(HIGHWAYS_GEOJSON_URL)
      .then(async response => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        highwaysGeoJsonCache = data;
        return data;
      })
      .catch(error => {
        highwaysGeoJsonRequest = null;
        throw error;
      });
  }

  return highwaysGeoJsonRequest;
};

const HighwaysOverlayLayer = () => {
  const [geoJson, setGeoJson] = React.useState(() => highwaysGeoJsonCache);
  const [isLoading, setIsLoading] = React.useState(() => !highwaysGeoJsonCache);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    let isMounted = true;

    if (highwaysGeoJsonCache) {
      setGeoJson(highwaysGeoJsonCache);
      setIsLoading(false);
      return undefined;
    }

    setIsLoading(true);
    setError('');

    loadHighwaysGeoJson()
      .then(data => {
        if (!isMounted) return;
        setGeoJson(data);
        setIsLoading(false);
      })
      .catch(fetchError => {
        if (!isMounted) return;
        setIsLoading(false);
        setError(
          fetchError?.message || 'Không thể tải dữ liệu cao tốc Việt Nam'
        );
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <LayerGroup>
      <Pane name={HIGHWAYS_PANE_NAME} style={{ zIndex: 350 }}>
        {geoJson && (
          <GeoJSON
            data={geoJson}
            style={HIGHWAYS_LAYER_STYLE}
            pane={HIGHWAYS_PANE_NAME}
            interactive={false}
          />
        )}
      </Pane>
    </LayerGroup>
  );
};

export default React.memo(HighwaysOverlayLayer);
